// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1ekG-","content":"GlobalSearch_content__3gMcx"};